import { transport } from 'config/transport';

export function callApiGetListOfThuMamNon(congDoanId, month, year) {
    return transport.get(`/mamnon/${congDoanId}/thuchi/thumamnon`, { params: { month, year } });
}
